import {
  buildPasswordResetClientState,
  getPasswordResetNavigation,
  PASSWORD_RESET_REQUIRED_STORAGE_KEY,
} from '../utils/authRequest';
import { clearCommerceSessionStorage } from '../utils/commerceSessionStorage';

function isMobileFlowPath() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/m/');
}

export function handleApiAuthError(error) {
  const status = error.response?.status;
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';

  if (status === 401) {
    if (isMobileFlowPath()) {
      const errorType = error.response?.data?.message?.includes('expired')
        ? 'token_expired'
        : 'invalid_token';
      window.location.href = `/m/error/${errorType}`;
    } else {
      clearCommerceSessionStorage();
      window.location.href = '/login';
    }
    return;
  }

  const passwordReset = buildPasswordResetClientState(getPasswordResetNavigation({
    status,
    code: error.response?.data?.code,
    currentPath,
  }));

  if (!passwordReset) {
    return;
  }

  localStorage.setItem(PASSWORD_RESET_REQUIRED_STORAGE_KEY, passwordReset.flag);
  if (passwordReset.redirectTo) {
    window.location.assign(passwordReset.redirectTo);
  }
}
